export default __webpack_public_path__ + "static/media/base-course-item-preview.fc7dc7e6.png";